var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilmmakersLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9198 8.9604C17.9198 12.867 14.7527 16.0341 10.8461 16.0341C6.93959 16.0341 3.77246 12.867 3.77246 8.9604C3.77246 5.05383 6.93959 1.88672 10.8461 1.88672C14.7527 1.88672 17.9198 5.05383 17.9198 8.9604Z",
    fill: "#A532FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9765 8.9604C16.9765 12.867 13.8093 16.0341 9.90279 16.0341C5.99623 16.0341 2.8291 12.867 2.8291 8.9604C2.8291 5.05383 5.99623 1.88672 9.90279 1.88672C13.8093 1.88672 16.9765 5.05383 16.9765 8.9604Z",
    fill: "#00CCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1474 8.9604C14.1474 12.867 10.9802 16.0341 7.07368 16.0341C3.16712 16.0341 0 12.867 0 8.9604C0 5.05383 3.16712 1.88672 7.07368 1.88672C10.9802 1.88672 14.1474 5.05383 14.1474 8.9604Z",
    fill: "#FE5C53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0907 8.9604C15.0907 12.867 11.9236 16.0341 8.01704 16.0341C4.11048 16.0341 0.943359 12.867 0.943359 8.9604C0.943359 5.05383 4.11048 1.88672 8.01704 1.88672C11.9236 1.88672 15.0907 5.05383 15.0907 8.9604Z",
    fill: "#FFD264"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0341 8.9604C16.0341 12.867 12.867 16.0341 8.9604 16.0341C5.05384 16.0341 1.88672 12.867 1.88672 8.9604C1.88672 5.05383 5.05384 1.88672 8.9604 1.88672C12.867 1.88672 16.0341 5.05383 16.0341 8.9604Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1295 8.96028C11.1295 10.1581 10.1581 11.1295 8.96028 11.1295C7.76247 11.1295 6.79102 10.1581 6.79102 8.96028C6.79102 7.76247 7.76247 6.79102 8.96028 6.79102C10.1581 6.79102 11.1295 7.76247 11.1295 8.96028Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmmakersLogo);
export default __webpack_public_path__ + "static/media/filmmakers-logo.8b7e1dc44956c9a558e8d33aca0b982e.svg";
export { ForwardRef as ReactComponent };